import { render } from "./AdultAppointmentPassTable.vue?vue&type=template&id=34183815"
import script from "./AdultAppointmentPassTable.vue?vue&type=script&lang=js"
export * from "./AdultAppointmentPassTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__